import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BlockRenderer from '../components/BlockRenderer';
import AuthRequiredLink from '../components/AuthRequiredLink';
import { usePageInit } from '../hooks/usePageInit';
import './PolicyPage.css';

type PolicyDoc = {
  id?: string;
  title?: string;
  blocks?: any[];
};

export default function CommercialTransactionsPage() {
  usePageInit();
  const [policy, setPolicy] = useState<PolicyDoc | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        const snap = await getDoc(doc(db, 'policies', 'tokushoho'));
        if (snap.exists()) {
          const data = snap.data() as PolicyDoc;
          setPolicy({ id: snap.id, ...data });
        }
      } catch (error) {
        console.error('Error fetching commercial transactions:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPolicy();
  }, []);

  return (
    <div className="m-application theme--light transition-page" id="app">
      <div className="loading"></div>
      <div className="m-content joker joker-var" id="main-wrap">
        <div className="main-wrap">
          <Header />
          <div className="policy-page">
            <div className="page-wrap">
              <div className="hidden-md-up">
                <div className="logo logo-header">
                  <AuthRequiredLink to="/">
                    <img src="/assets/images/mobile-logo.png" alt="logo" />
                  </AuthRequiredLink>
                </div>
              </div>
              <div className="container inner-wrap max-md">
                <AuthRequiredLink className="waves-effect btn-icon backtohome fragment-fadeUp" to="/">
                  <span>
                    <i className="ion-ios-home-outline"></i>
                    <i className="ion-ios-arrow-thin-left"></i>
                  </span>
                </AuthRequiredLink>
                <div className="card policy-box fragment-fadeUp">
                  <div className="policy-content">
                    <h1 className="policy-title">特定商取引に基づく表記</h1>
                    {loading ? (
                      <div className="loading-container">
                        <p>読み込み中...</p>
                      </div>
                    ) : policy && policy.blocks && policy.blocks.length > 0 ? (
                      <div className="policy-body">
                        <BlockRenderer blocks={policy.blocks} />
                      </div>
                    ) : (
                      <div className="policy-body">
                        <p>コンテンツがまだ設定されていません。</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer withDeco={true} />
        </div>
      </div>
    </div>
  );
}

